module.exports = __webpack_public_path__ + "img/zx.630e310a.png";